module.exports = __webpack_public_path__ + "img/help.e913a24a.svg";